import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './highlight.routes';
import addHtml from './modal/add.html';

export class HighLightsController {
    $http;
    socket;
    awesomeThings = [];
    highlights = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('highlight');
        });
    }

    $onInit() {
        if (this.$cookies.get('token')) {

            this.$http.get('/api/highlights/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;
                        this.highlights = response.data.data;

                        this.socket.syncUpdates('highlights', this.highlights);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    search() {
        if (this.$cookies.get('token')) {

            this.$http.get('/api/highlights/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': this.currentPage - 1,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.highlights = response.data.data;

                        this.socket.syncUpdates('highlights', this.highlights);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    highLight(highlight, index) {
        this.$http.delete(`/api/highlights/${highlight.highlight_id}`).then(response => {
            if (response.status === 204) {
                this.highlights.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    // addSurvey() {
    //   const surveys = this.surveys;
    //   this.$uibModal.open({
    //     template: addHtml,
    //     size: 'lg',
    //     /*@ngInject*/
    //     controller: function($scope, $http, $uibModalInstance) {
    //       $scope.vm = {};
    //       $scope.save = function(myForm) {
    //         if (myForm.$valid === false) {
    //           return false;
    //         } else {
    //           $http.post('/api/surveys', $scope.vm).then((response) => {
    //             $uibModalInstance.close(response.data);
    //           }, (error) => {
    //             console.log(error);
    //           });
    //         }
    //       };
    //       $scope.cancel = function() {
    //         $uibModalInstance.close();
    //       };
    //     }
    //   })
    //     .result.then(function(ret) {
    //     if (ret) {
    //       surveys.push(ret);
    //     }
    //   }, function () {
    //   });
    // }

}

export default angular.module('tttApp.highlight', [uiRouter])
    .config(routing)
    .component('highlight', {
        template: require('./highlight.html'),
        controller: HighLightsController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/highlight/highlight.component.js